import { Directive, ElementRef, Renderer2, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appAsterisk]',

})
export class AsteriskDirective implements OnInit, OnChanges {

    @Input('appAsterisk') isRequired: boolean = true;

    constructor (private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit () {

        const showAsterisk = this.isRequired === true;
        if (showAsterisk) {
            const asterisk = this.createAsterisk();
            this.renderer.appendChild(this.el.nativeElement, asterisk);
        }

    }

    ngOnChanges (changes: SimpleChanges): void {

        if (changes['isRequired'] && !changes['isRequired'].isFirstChange()) {

            let isRequiredValue = changes['isRequired'].currentValue;
            isRequiredValue ? this.addAsterisk() : this.removeAsterisk();

        }

    }

    private createAsterisk() {

        const asterisk = this.renderer.createElement('span');
        this.renderer.setProperty(asterisk, 'id', 'asterisk-span');
        this.renderer.setProperty(asterisk, 'innerHTML', '*');
        this.renderer.addClass(asterisk, 'text-danger-color');
        this.renderer.addClass(asterisk, 'mx-1');

        return asterisk;

    }

    private addAsterisk() {

        const showAsterisk = this.isRequired === true;
        const asterisk     = this.createAsterisk();

        if (showAsterisk) {
            this.renderer.appendChild(this.el.nativeElement, asterisk);
        }

    }

    private removeAsterisk() {

        const asterisk = this.el.nativeElement.querySelector('#asterisk-span');
        this.renderer.removeChild(this.el.nativeElement, asterisk);

    }

}
